import React from 'react';
import { Card, Button, Space, Input } from 'antd';
import { DeleteFilled } from '@ant-design/icons';
import DragHandle from 'components/DragHandle';
import CenterContent from 'components/CenterContent';

const EditDashboardContent = ({ content, removeContent, removing, contentTitles, setContentTitles }) => (
  <Card
    className="dashboard__content"
    title={(
      <Space>
        <DragHandle />
        <Input style={{ width: 350 }} value={contentTitles[content.id]} onChange={(e) => setContentTitles({ ...contentTitles, [content.id]: e.target.value })} />
      </Space>
    )}
    extra={(
      <Button
        danger
        loading={removing}
        icon={<DeleteFilled />}
        onClick={() => {
          removeContent(content.id);
        }}
      />
      )}
  >
    <CenterContent style={{ padding: '16px' }}>Move content by dragging it from the top left corner</CenterContent>
  </Card>
);

export default EditDashboardContent;
